const LoyaltyModule = () => import('./LoyaltyWalletReportModule.vue')
const WalletTransactionsReportIndex = () => import('./views/WalletTransactionsReportIndex.vue')

export const loyaltyWalletReportRoute = {
  path: '/report/loyalty',
  component: LoyaltyModule,
  meta: {
    title: 'LoyaltyWalletReport',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'wallet-transactions',
      name: 'loyalty-transactions-report',
      meta: {
        permission: 'loyalty_wallet.view',
      },
      component: WalletTransactionsReportIndex,
    },
  ],
}
